var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Achats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Colis entrant vers un point de reception.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 256 163.2 L 461.8 282 L 256 400.8 L 50.2 282 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 183,
    x2: 84.5,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 284.6,
    y1: 199.5,
    x2: 113.1,
    y2: 298.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 313.2,
    y1: 216,
    x2: 141.7,
    y2: 315
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 341.7,
    y1: 232.5,
    x2: 170.3,
    y2: 331.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 370.3,
    y1: 249,
    x2: 198.8,
    y2: 348
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 398.9,
    y1: 265.5,
    x2: 227.4,
    y2: 364.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 427.5,
    y1: 282,
    x2: 256,
    y2: 381
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 183,
    x2: 427.5,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 227.4,
    y1: 199.5,
    x2: 398.9,
    y2: 298.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 198.8,
    y1: 216,
    x2: 370.3,
    y2: 315
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 170.3,
    y1: 232.5,
    x2: 341.7,
    y2: 331.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 141.7,
    y1: 249,
    x2: 313.2,
    y2: 348
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 113.1,
    y1: 265.5,
    x2: 284.6,
    y2: 364.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 84.5,
    y1: 282,
    x2: 256,
    y2: 381
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 358.9 268.8 L 307.4 298.5 L 307.4 344.7 L 358.9 315 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 256 268.8 L 307.4 298.5 L 307.4 344.7 L 256 315 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 307.4 239.1 L 358.9 268.8 L 307.4 298.5 L 256 268.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 307.4,
    y1: 285.3,
    x2: 307.4,
    y2: 239.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 307.4,
    y1: 285.3,
    x2: 358.9,
    y2: 315
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 307.4,
    y1: 285.3,
    x2: 256,
    y2: 315
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 307.4 239.1 L 358.9 268.8 L 307.4 298.5 L 256 268.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 358.9,
    y1: 268.8,
    x2: 358.9,
    y2: 315
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 307.4,
    y1: 298.5,
    x2: 307.4,
    y2: 344.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 256,
    y1: 268.8,
    x2: 256,
    y2: 315
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 358.9,
    y1: 315,
    x2: 307.4,
    y2: 344.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 307.4,
    y1: 344.7,
    x2: 256,
    y2: 315
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 307.4 281.7 L 364.6 314.7 L 307.4 347.7 L 250.3 314.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 flow",
    d: "M 178.8 118.6 L 216 169.8 L 256 202.8 L 293.2 250.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "drift d7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 230.3 98.8 L 187.4 123.6 L 187.4 173.1 L 230.3 148.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 144.5 98.8 L 187.4 123.6 L 187.4 173.1 L 144.5 148.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 187.4 74.1 L 230.3 98.8 L 187.4 123.6 L 144.5 98.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 187.4,
    y1: 123.6,
    x2: 187.4,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 187.4,
    y1: 123.6,
    x2: 230.3,
    y2: 148.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 187.4,
    y1: 123.6,
    x2: 144.5,
    y2: 148.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 187.4 74.1 L 230.3 98.8 L 187.4 123.6 L 144.5 98.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 230.3,
    y1: 98.8,
    x2: 230.3,
    y2: 148.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 187.4,
    y1: 123.6,
    x2: 187.4,
    y2: 173.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 144.5,
    y1: 98.8,
    x2: 144.5,
    y2: 148.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 230.3,
    y1: 148.3,
    x2: 187.4,
    y2: 173.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 187.4,
    y1: 173.1,
    x2: 144.5,
    y2: 148.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 216,
    cy: 169.8,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 216,
    cy: 169.8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d4",
    cx: 256,
    cy: 202.8,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 256,
    cy: 202.8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d8",
    cx: 293.2,
    cy: 250.7,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 293.2,
    cy: 250.7,
    r: 3
  })), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 227.4 295.2 L 198.8 311.7 L 198.8 334.8 L 227.4 318.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 170.3 295.2 L 198.8 311.7 L 198.8 334.8 L 170.3 318.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 198.8 278.7 L 227.4 295.2 L 198.8 311.7 L 170.3 295.2 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 198.8,
    y1: 301.8,
    x2: 198.8,
    y2: 278.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 198.8,
    y1: 301.8,
    x2: 227.4,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 198.8,
    y1: 301.8,
    x2: 170.3,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 198.8 278.7 L 227.4 295.2 L 198.8 311.7 L 170.3 295.2 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 227.4,
    y1: 295.2,
    x2: 227.4,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 198.8,
    y1: 311.7,
    x2: 198.8,
    y2: 334.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 170.3,
    y1: 295.2,
    x2: 170.3,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 227.4,
    y1: 318.3,
    x2: 198.8,
    y2: 334.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 198.8,
    y1: 334.8,
    x2: 170.3,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.79e320a0c2e7dae83fdb079660994e03.svg";
export { ForwardRef as ReactComponent };